import { LoginCallback } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

function LoginErrorHandler({ error }) {
  const navigate = useNavigate();

  useEffect(() => {
    const sendLog = async () => {
      if (error.error === 'access_denied' || error.errorCode === 'E0000006') {
        navigate('/no-access?reason=Access Denied');
      } else if (
        error.error === 'server_error' ||
        error.error === 'temporarily_unavailable'
      ) {
        navigate('/no-access?reason=Temporarily Okta Server Unavailable');
      }
    };
    sendLog();
  }, [error, navigate]);

  return null;
}

export default function CustomLoginCallback() {
  return <LoginCallback errorComponent={LoginErrorHandler} />;
}
